import { render, staticRenderFns } from "./GoogleSourceButton.vue?vue&type=template&id=b7b40fa4&scoped=true"
import script from "./GoogleSourceButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleSourceButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GoogleSourceButton.vue?vue&type=style&index=0&id=b7b40fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b40fa4",
  null
  
)

export default component.exports